import {
  GraphQLInputObjectType,
  GraphQLNonNull,
  GraphQLID,
  GraphQLList,
  GraphQLFieldConfig,
  GraphQLObjectType
} from 'graphql'
import { jobStatusType } from '../types/job-status'

interface Context {
  readonly connector: {
    readonly executeDelete: (url: string, data?: any) => Promise<any>
  }
}

const deleteVulnerabilitiesResultType = new GraphQLNonNull(
  new GraphQLObjectType({
    name: 'VulnerabilityDeleteResult',
    fields: () => ({
      jobStatus: {
        description:
          'The status of the background job that is deleting the vulnerabilities',
        type: new GraphQLNonNull(jobStatusType)
      }
    })
  })
)

interface ByIDsArgs {
  readonly input?: {
    readonly organizationID: string
    readonly ids: string[]
  }
}

export const deleteVulnerabilities: GraphQLFieldConfig<
  undefined,
  Context,
  ByIDsArgs
> = {
  type: deleteVulnerabilitiesResultType,
  args: {
    input: {
      type: new GraphQLInputObjectType({
        name: 'DeleteVulnerabilitiesMutationArg',
        fields: () => ({
          organizationID: {
            description:
              'The ID of the organization of the vulnerabilities being deleted',
            type: new GraphQLNonNull(GraphQLID)
          },
          ids: {
            description: 'The IDs of the vulnerabilities to delete',
            type: new GraphQLNonNull(
              new GraphQLList(new GraphQLNonNull(GraphQLID))
            )
          }
        })
      })
    }
  },
  async resolve(_source, args, { connector }) {
    if (!args.input) {
      throw new Error('mutation input parameter is required')
    }
    const { organizationID, ids: traces } = args.input

    const { job_id: id } = await connector.executeDelete(
      `${organizationID}/orgtraces`,
      {
        traces
      }
    )

    return {
      jobStatus: {
        id,
        total: traces.length,
        progress: 0
      }
    }
  }
}
